import React from 'react';
import { Button } from '../../../Components/MUIs';
import { Box, Typography } from '@mui/material';
import checkImage from '../../../Assets/Images/check.png';
import BackClickBottomSheetTbmEnd from '../../../Components/Ui/BackClickBottomSheetTbmEnd';
import { useOutletContext } from 'react-router-dom';
import { useSelector } from 'react-redux';

function M_TBG_BASIC_09(props) {
  const { ToggleDrawer } = useOutletContext();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  return (
    <>
      <Box
        sx={{
          minHeight: '70vh',
          p: 2,
          mb: '92px', // 앱바, 탭 높이만큼 위로 이동
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            alignSelf: 'flex-start',
            ml: 2.5,
            mb: '-38px', // 이미지 크기의 절반만큼 아래로 이동
          }}
        >
          <img src={checkImage} />
        </Box>
        <Box
          sx={{
            p: 2,
            px: 1,
            pt: 8,
            pb: 6,
            mb: 5,
            width: '100%',
            border: 1,
            borderColor: '#F3F4F6',
            borderRadius: 5,
            backgroundColor: '#fff',
            boxShadow: 0,
          }}
        >
          <Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            금일 TBM 회의가 성공적으로 종료되었습니다.
          </Typography>
          <Typography
            sx={{ fontSize: '14px', color: '#828282', textAlign: 'center' }}
          >
            오늘도 안전을 위해 함께해주셔서 감사합니다.
          </Typography>
        </Box>
        <Button
          sx={{
            width: '100%',
            height: '36px',
            borderRadius: '18px',
          }}
          name="TBM 완료"
          onClick={() => props.Complete()}
        />
      </Box>
      {bottomSheetState.bottom &&
        bottomSheetState.type === 'backClickTbmEnd' && (
          <BackClickBottomSheetTbmEnd
            open={true}
            ToggleDrawer={ToggleDrawer}
            TbmEnd={props.TbmEnd}
          />
        )}
    </>
  );
}

export default M_TBG_BASIC_09;
